import { AccessRequestForm } from '@NewRequest/organisms/AccessRequestForm';
import { Loader } from '@common/ui/Loader';
import { useMemo, useState } from 'react';

import AddAccessProcess from '@MyAccess/organisms/AddAccessProcess';
import { SESSION_ID_PARAM } from '@MyAccess/utils/consts';
import { FormState } from '@MyRequests/helpers';
import {
  AccessRequestSubmittedClientResponse,
  ResourceFilterType,
  useGetAccessSessionRequestTemplate,
  useListResourceTypes,
} from '@apono/client-app-sdk';
import { useNavigate } from 'react-router-dom';
import routes from '@routes';

function AccessRequestFormFilledSession({ sessionId }: { sessionId: string }) {
  const { data: sessionData, isFetched: isASFetched } = useGetAccessSessionRequestTemplate({ id: sessionId });
  const { data: resourceTypes, isFetched: isRTFetched } = useListResourceTypes({
    integrationId: sessionData?.integrations[0]?.id ?? '',
    limit: 1,
  });

  const hasIntegrationButNoResourceType = !!(
    isASFetched &&
    isRTFetched &&
    sessionData?.integrations.length &&
    !sessionData?.resource_types.length &&
    !resourceTypes?.pages[0]?.data.length
  );

  const [accessRequestResponse, setAccessRequestResponse] = useState<AccessRequestSubmittedClientResponse>();
  const navigate = useNavigate();

  const sessionFormState: FormState | undefined = useMemo(() => {
    if (!sessionData) return undefined;
    const { integrations, resource_types, permissions, resources } = sessionData;
    return {
      selectedIntegration: integrations.map((integration) => ({
        value: integration.id,
        label: integration.name,
        subLabel: integration.type,
        icon: integration.icons?.svg,
      }))?.[0],
      selectedResourceType: resource_types.map((resourceType) => ({
        value: resourceType.id,
        label: resourceType.name,
        icon: resourceType.icons?.svg,
      }))?.[0],
      selectedPermission: permissions.map((permission) => ({
        value: permission.id,
        label: permission.name,
      }))?.[0],
      selectedMultiplePermission: permissions.map((permission) => ({
        value: permission.id,
        label: permission.name,
      })),
      selectedResource: resources.map((resource) => ({
        value: `${ResourceFilterType.Id}:${resource.id}`,
        label: resource.path,
        icon: resource.type?.icons?.svg,
      })),
      custom_fields: {},
      selectedBundle: null,
      selectedAccessUnit: [],
      selectedDuration: null,
      justification: '',
    };
  }, [sessionData]);

  if (!sessionFormState) return <Loader />;

  if (accessRequestResponse) {
    return (
      <AddAccessProcess
        requestIds={accessRequestResponse.request_ids}
        onCheckDetails={() => navigate(routes.OpenRequests.path)}
        onUseAccess={() => navigate(`${routes.MyAccess.path}?${SESSION_ID_PARAM}=${sessionId}`)}
      />
    );
  }

  return (
    <AccessRequestForm
      sessionId={sessionId}
      initFormState={sessionFormState}
      showAlert={hasIntegrationButNoResourceType}
      onSuccess={(accessReqRes) => setAccessRequestResponse(accessReqRes)}
      disabledInputs
    />
  );
}

export default AccessRequestFormFilledSession;
